module.exports = __webpack_public_path__ + "static/media/empty_benefits.3c733ef7.png";